"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Default_1 = require("./template/Default");
var Scheme_1 = require("react-sidenav/types/Scheme");
var _a = React.createContext({
    selectedPath: '',
    template: { item: Default_1.item, children: Default_1.children },
    theme: {},
    scheme: Scheme_1.Scheme.default
}), Provider = _a.Provider, Consumer = _a.Consumer;
exports.Provider = Provider;
exports.Consumer = Consumer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidenav/Context.js
// module id = ./node_modules/react-sidenav/Context.js
// module chunks = 0